// Layout Management -- Manual for now.
// Use spreadsheet : https://docs.google.com/spreadsheets/d/1A4PmA1vvH18qIZBPB-gn-ggouTom6zaFCcaX9eP5ps0/edit#gid=0 for a list of node names

// export var NodeLayout = {

//   //format:
//   // CODE : {parentGroup0: {x0,y0}, parentGroup1:{x1,y1}} -- to facilitate nodes belonging to multiple groups
//   //      parentGroups are ordered by numerical group; so ece302 would have 0 = area 4, 1 = area 5 , 2 = area 6...

//   "ECE526": { 0: { x: 777, y: 777 }, },
//   "ECE463": { 0: { x: 777, y: 777 }, },
//   "ECE520": { 0: { x: 777, y: 777 }, },
//   "ECE313": { 0: { x: 777, y: 777 }, },
//   "ECE314": { 0: { x: 777, y: 777 }, },
//   "ECE419": { 0: { x: 777, y: 777 }, },
//   "CSC444": { 0: { x: 777, y: 777 }, },
//   "CSC470": { 0: { x: 777, y: 777 }, },
//   "ECE568": { 0: { x: 777, y: 777 }, },
//   "ECE454": { 0: { x: 777, y: 777 }, },
//   "ECE344": { 0: { x: 777, y: 777 }, },
//   "ECE361": { 0: { x: 777, y: 777 }, },
//   "ECE461": { 0: { x: 777, y: 777 }, },
//   "ECE466": { 0: { x: 777, y: 777 }, },
//   "ECE302": { 0: { x: 777, y: 777 }, },
//   "ECE316": { 0: { x: 777, y: 777 }, },
//   "ECE417": { 0: { x: 777, y: 777 }, },
//   "ECE464": { 0: { x: 777, y: 777 }, },
//   "ECE537": { 0: { x: 777, y: 777 }, },
//   "ECE421": { 0: { x: 777, y: 777 }, },
//   "ECE462": { 0: { x: 777, y: 777 }, },
//   "ECE516": { 0: { x: 777, y: 777 }, },
//   "ECE431": { 0: { x: 777, y: 777 }, },
//   "ECE442": { 0: { x: 777, y: 777 }, },
//   "ECE335": { 0: { x: 777, y: 777 }, },
//   "ECE334": { 0: { x: 777, y: 777 }, },
//   "ECE437": { 0: { x: 777, y: 777 }, },
//   "CIV100": { 0: { x: 777, y: 777 }, },
//   "MAT186": { 0: { x: 777, y: 777 }, },
//   "MAT188": { 0: { x: 777, y: 777 }, },
//   "APS111": { 0: { x: 777, y: 777 }, },
//   "APS110": { 0: { x: 777, y: 777 }, },
//   "MIE100": { 0: { x: 777, y: 777 }, },
//   "MAT187": { 0: { x: 777, y: 777 }, },
//   "ECE110": { 0: { x: 777, y: 777 }, },
//   "APS112": { 0: { x: 777, y: 777 }, },
//   "APS105": { 0: { x: 777, y: 777 }, },
//   "ECE101": { 0: { x: 777, y: 777 }, },
//   "MAT291": { 0: { x: 777, y: 777 }, },
//   "MAT290": { 0: { x: 777, y: 777 }, },
//   "ECE212": { 0: { x: 777, y: 777 }, },
//   "ECE241": { 0: { x: 777, y: 777 }, },
//   "ECE244": { 0: { x: 777, y: 777 }, },
//   "ECE221": { 0: { x: 777, y: 777 }, },
//   "ECE216": { 0: { x: 777, y: 777 }, },
//   "ECE231": { 0: { x: 777, y: 777 }, },
//   "ECE243": { 0: { x: 777, y: 777 }, },
//   "ECE297": { 0: { x: 777, y: 777 }, },
//   "CSC343": { 0: { x: 777, y: 777 }, },
//   "CSC418": { 0: { x: 777, y: 777 }, },
//   "ECE467": { 0: { x: 777, y: 777 }, },
//   "ECE345": { 0: { x: 777, y: 777 }, },
//   "ECE326": { 0: { x: 777, y: 777 }, },
//   "ECE496": { 0: { x: 777, y: 777 }, },
//   "ECE472": { 0: { x: 777, y: 777 }, },
//   "ECE430": { 0: { x: 777, y: 777 }, },
//   "ECE331": { 0: { x: 777, y: 777 }, },
//   "ECE412": { 0: { x: 777, y: 777 }, },
//   "ECE470": { 0: { x: 777, y: 777 }, },
//   "ECE410": { 0: { x: 777, y: 777 }, },
//   "ECE311": { 0: { x: 777, y: 777 }, },
//   "ECE411": { 0: { x: 777, y: 777 }, },
//   "BME455": { 0: { x: 777, y: 777 }, },
//   "CHE354": { 0: { x: 777, y: 777 }, },
//   "MIE331": { 0: { x: 777, y: 777 }, },
//   "ECE448": { 0: { x: 777, y: 777 }, },
//   "BME440": { 0: { x: 777, y: 777 }, },
//   "BME595": { 0: { x: 777, y: 777 }, },
//   "CHE353": { 0: { x: 777, y: 777 }, },
//   "ECE445": { 0: { x: 777, y: 777 }, },
//   "ECE446": { 0: { x: 777, y: 777 }, },
// }

const ClusterRadius = 1000;

export const AreaLayoutCore = [
  { x: 0, y: 0 },
  { x: 0, y: -ClusterRadius },
  {
    x: ClusterRadius * Math.sin(Math.PI / 3),
    y: -ClusterRadius * Math.cos(Math.PI / 3),
  },
  {
    x: ClusterRadius * Math.sin(Math.PI / 3),
    y: ClusterRadius * Math.cos(Math.PI / 3),
  },
  { x: 0, y: ClusterRadius },
  {
    x: -ClusterRadius * Math.sin(Math.PI / 3),
    y: ClusterRadius * Math.cos(Math.PI / 3),
  },
  {
    x: -ClusterRadius * Math.sin(Math.PI / 3),
    y: -ClusterRadius * Math.cos(Math.PI / 3),
  },
  { x: ClusterRadius * 1.9, y: ClusterRadius / 1.5 },
  { x: ClusterRadius * 1.9, y: -ClusterRadius / 1.5 },
];

var AreaLayoutBase = [
  { x: 0, y: 0 },
  { x: 0, y: -ClusterRadius },
  {
    x: ClusterRadius * Math.sin(Math.PI / 3),
    y: -ClusterRadius * Math.cos(Math.PI / 3),
  },
  {
    x: ClusterRadius * Math.sin(Math.PI / 3),
    y: ClusterRadius * Math.cos(Math.PI / 3),
  },
  { x: 0, y: ClusterRadius },
  {
    x: -ClusterRadius * Math.sin(Math.PI / 3),
    y: ClusterRadius * Math.cos(Math.PI / 3),
  },
  {
    x: -ClusterRadius * Math.sin(Math.PI / 3),
    y: -ClusterRadius * Math.cos(Math.PI / 3),
  },
  { x: ClusterRadius * 1.9, y: ClusterRadius / 1.5 },
  { x: ClusterRadius * 1.9, y: -ClusterRadius / 1.5 },
];

//when a cluster is opened, multiple other clusters may require shifting
const AreaEffectors = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8], //core expansion requires all other clust. expansions
  [1],
  [2, 8],
  [3, 7],
  [4],
  [5],
  [6],
  [7],
  [8],
];

export const GetClusterCenters = (expansionArray) => {
  var AreaLayout = AreaLayoutBase; //cp as ref by default
  var FullExpansionArray = [...AreaEffectors];
  for (var i = 0; i < 9; i++) {
    if (!expansionArray[i]) FullExpansionArray[i] = []; //if hidden, expand nothing
  }

  for (i = 0; i < 9; i++) {
    AreaLayout[i].x =
      AreaLayoutCore[i].x *
      (ValueExistsInArray2D(FullExpansionArray, i) ? 1 : 0.5);
    AreaLayout[i].y =
      AreaLayoutCore[i].y *
      (ValueExistsInArray2D(FullExpansionArray, i) ? 1 : 0.5);
  }
  // console.log("AL / ALC")
  // console.dir(AreaLayout)
  // console.dir(AreaLayoutCore)
  return AreaLayout;
};

const ValueExistsInArray2D = (arr, val) => {
  for (var i = 0; i < arr.length; i++) {
    for (var j = 0; j < arr[i].length; j++) {
      if (arr[i][j] === val) return true;
    }
  }
  return false;
};
